const moduleName = 'popups';

export function popups() {

    function toggleModal (modalId) {
        const modal = document.querySelector(`#${modalId}`);
        if (modal) {
            modal.classList.toggle('_opened');
            if (document.querySelectorAll('.modal._opened').length) {
                document.body.classList.add('has-modal');
                bodyFixPosition();
            } else {
                document.body.classList.remove('has-modal');
                bodyUnfixPosition();
            }
        }
    }

    function windowOnClick (event) {
        const target = event.target;
        if (event.target.classList.contains('modal')) {
            toggleModal(target.id);
        }
    }

    function closeAllModals () {
        document.querySelectorAll('.modal._opened').forEach(modal => {
            toggleModal(modal.id);
            document.body.classList.toggle('has-modal');
        });
    }

    document.addEventListener('click', function (e) {
        const target = e.target;

        if (target.classList.contains('js-open-modal') || target.closest('.js-open-modal')) {
            e.preventDefault();
            const modalId = target.dataset.modalId ? target.dataset.modalId : target.closest('.js-open-modal').dataset.modalId;
            const modal = document.querySelector(`#${modalId}`);

            if (!modalId) {
                throw new Error('Не указан ID модального окна или отсутствует обязательный атрибут data-modal-id у триггера.');
            }

            if (!modal) {
                throw new Error(`Не могу найти модальное окно с ID: ${modalId}`);
            }

            closeAllModals();
            toggleModal(modalId);
        }
        if (target.classList.contains('js-close-modal')) {
            const modalId = target.closest('.modal').id;
            toggleModal(modalId);
        }
    });

    window.addEventListener('click', windowOnClick);

    window.toggleModal = toggleModal;

    function bodyFixPosition() {
        setTimeout( function() {
            if ( !document.body.hasAttribute('data-body-scroll-fix') ) {
                let scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                document.body.setAttribute('data-body-scroll-fix', scrollPosition); // Cтавим атрибут со значением прокрутки
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.top = '-' + scrollPosition + 'px';
                document.body.style.left = '0';
                document.body.style.width = '100%';
            }

        } );
    }

    function bodyUnfixPosition() {
        if ( document.body.hasAttribute('data-body-scroll-fix') ) {
            let scrollPosition = document.body.getAttribute('data-body-scroll-fix');
            document.body.removeAttribute('data-body-scroll-fix');
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.width = '';
            window.scroll(0, scrollPosition);
        }
    }
}
